import React from "react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";

const fmt = (d) => {
  if (!d) return "";
  return d.toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" });
};

const toIso = (d) => {
  if (!d) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const fromIso = (s) => {
  if (!s) return undefined;
  // Accept YYYY-MM-DD or ISO timestamp
  const d = new Date(s.length > 10 ? s : s + "T00:00:00");
  return isNaN(d.getTime()) ? undefined : d;
};

/**
 * Controlled date picker that wraps shadcn Popover + Calendar.
 * value: YYYY-MM-DD string (or empty)
 * onChange: (YYYY-MM-DD string) => void
 */
export default function DatePicker({ value, onChange, placeholder = "Pick a date", testId }) {
  const date = fromIso(value);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="w-full mt-1.5 inline-flex items-center justify-between rounded-none border border-zinc-200 bg-white h-10 px-3 text-sm hover:border-[#002FA7] focus:outline-none focus:border-[#002FA7] transition-colors"
        >
          <span className={date ? "metric text-zinc-900" : "text-zinc-400"}>
            {date ? fmt(date) : placeholder}
          </span>
          <CalendarIcon className="w-3.5 h-3.5 text-zinc-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="rounded-none p-0 w-auto" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(d) => onChange(d ? toIso(d) : "")}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
